import Script from 'next/script';

/**
 * DilaCRM Website Chat Widget (Salesmate `web_widget` channel).
 *
 * Loads the embeddable chat bubble/panel from the DilaCRM instance this site
 * is wired to (crm.dilaweb.com). The script is a self-contained, Shadow-DOM
 * isolated IIFE (see @salesmate/widget) — it renders nothing until it has
 * mounted, fails silently on any error, and never touches this page's DOM
 * outside its own shadow root. `data-salesmate-widget` is the widget's public
 * key: safe to ship client-side, not a secret (see the embed snippet in the
 * DilaCRM admin at crm.dilaweb.com/web-widget).
 *
 * `afterInteractive` (Next's default background-load strategy) mirrors how
 * Plausible is loaded elsewhere in this layout — the widget isn't needed for
 * first paint, so it shouldn't compete with the LCP path.
 */
export default function WebWidgetScript() {
  return (
    <Script
      id="dilacrm-web-widget"
      strategy="afterInteractive"
      src="https://crm.dilaweb.com/widget.js"
      data-salesmate-widget="UFi-aZLYAYMBmXagbQ6p-HfH7whTJ56C"
    />
  );
}
